import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { EventService } from '../../../../services/event.service';

export interface DlgVolunteersData {
  title: string;
  volunteers: any[];
  volunteersRequired: number;
  groupId: string;
  eventId: string;
  subEventId: string;
}

@Component({
  selector: 'app-dlg-volunteers',
  standalone: true,
  imports: [CommonModule, MomentPipe],
  templateUrl: './dlg-volunteers.component.html',
})
export class DlgVolunteersComponent {
  readonly dialogRef = inject(MatDialogRef<DlgVolunteersComponent>);
  readonly data = inject<DlgVolunteersData>(MAT_DIALOG_DATA);
  private eventService = inject(EventService);

  title: string = '';
  volunteers: any[] = [];
  volunteersRequired: number = 0;
  deletingMap: Record<string, boolean> = {};

  constructor() {
    this.title = this.data.title;
    this.volunteers = this.data.volunteers || [];
    this.volunteersRequired = this.data.volunteersRequired || 0;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  getInitials(name: string): string {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    if (parts.length > 1) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }

  async deleteVolunteer(volunteer: any) {
    if (!this.data.groupId || !this.data.eventId || !this.data.subEventId) return;

    this.deletingMap[volunteer.uid] = true;
    try {
      const calendarEventId = `event_${this.data.eventId}_${this.data.subEventId}`;
      await this.eventService.unvolunteerForEvent(
        this.data.groupId,
        calendarEventId,
        volunteer.uid,
        this.data.eventId
      );
      this.volunteers = this.volunteers.filter(v => v.uid !== volunteer.uid);
    } catch (err: any) {
      console.error('Failed to remove volunteer:', err);
    } finally {
      this.deletingMap[volunteer.uid] = false;
    }
  }
}
